var _path, _path2, _g, _g2, _g3, _path3, _path4, _path5, _ellipse, _ellipse2, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 442,
    height: 292,
    viewBox: "0 0 442 292",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M267.715 170.418C267.715 194.023 248.579 213.159 224.973 213.159C201.368 213.159 182.232 194.023 182.232 170.418C182.232 146.813 201.368 127.677 224.973 127.677C248.579 127.677 267.715 146.813 267.715 170.418Z",
    fill: "url(#paint0_radial_2308_2056)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M258.227 170.418C258.227 188.783 243.339 203.671 224.974 203.671C206.608 203.671 191.72 188.783 191.72 170.418C191.72 152.053 206.608 137.165 224.974 137.165C243.339 137.165 258.227 152.053 258.227 170.418Z",
    fill: "url(#paint1_linear_2308_2056)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_2308_2056)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.58 170.418C257.58 188.426 242.981 203.024 224.973 203.024C206.966 203.024 192.367 188.426 192.367 170.418C192.367 152.41 206.966 137.812 224.973 137.812C242.981 137.812 257.58 152.41 257.58 170.418Z",
    fill: "url(#paint2_radial_2308_2056)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2308_2056)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M221.035 177.746V147.839C221.035 145.819 222.673 144.181 224.693 144.181C226.714 144.181 228.352 145.819 228.352 147.839V177.746C228.352 179.767 226.714 181.405 224.693 181.405C222.673 181.405 221.035 179.767 221.035 177.746Z",
    fill: "black"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2308_2056)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228.914 190.748C228.914 193.079 227.024 194.968 224.694 194.968C222.363 194.968 220.474 193.079 220.474 190.748C220.474 188.417 222.363 186.528 224.694 186.528C227.024 186.528 228.914 188.417 228.914 190.748Z",
    fill: "black"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M221.678 177.421V147.514C221.678 145.494 223.317 143.855 225.337 143.855C227.358 143.855 228.996 145.494 228.996 147.514V177.421C228.996 179.442 227.358 181.08 225.337 181.08C223.317 181.08 221.678 179.442 221.678 177.421Z",
    fill: "#292929"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M229.557 190.33C229.557 192.66 227.668 194.55 225.337 194.55C223.006 194.55 221.117 192.66 221.117 190.33C221.117 187.999 223.006 186.11 225.337 186.11C227.668 186.11 229.557 187.999 229.557 190.33Z",
    fill: "#292929"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M225.737 222.308C225.66 221.787 225.608 221.258 225.608 220.716C225.608 214.825 230.271 210.048 236.031 210.022C235.301 199.394 238.48 192.529 239.506 190.608C240.558 188.637 252.223 171.79 270.379 175.105C286.567 178.062 295.218 196.821 296.904 200.854C299.26 199.695 301.9 199.045 304.688 199.045C314.604 199.045 322.643 207.258 322.643 217.389C322.643 219.089 322.412 220.733 321.988 222.296C327.176 222.932 331.198 227.436 331.198 232.907C331.198 238.585 326.865 243.218 321.394 243.569V243.604H227.21V243.596C227.164 243.597 227.118 243.604 227.072 243.604C221.29 243.604 216.602 238.815 216.602 232.907C216.602 227.463 220.587 222.979 225.737 222.308Z",
    fill: "#25272A"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 225.722,
    cy: 179.658,
    rx: 74.9351,
    ry: 74.8453,
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeDasharray: "0.01 4"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 225.722,
    cy: 179.658,
    rx: 106.442,
    ry: 106.314,
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeDasharray: "0.01 4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M171.031 236.901C171.031 239.147 169.211 240.966 166.966 240.966C164.721 240.966 162.901 239.147 162.901 236.901C162.901 234.656 164.721 232.836 166.966 232.836C169.211 232.836 171.031 234.656 171.031 236.901Z",
    fill: "#FF00F5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M320.02 153.326C320.02 155.571 318.159 157.391 315.863 157.391C313.567 157.391 311.706 155.571 311.706 153.326C311.706 151.08 313.567 149.26 315.863 149.26C318.159 149.26 320.02 151.08 320.02 153.326Z",
    fill: "#E69F24"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M113.822 163.865C113.822 166.11 111.96 167.93 109.665 167.93C107.369 167.93 105.508 166.11 105.508 163.865C105.508 161.619 107.369 159.8 109.665 159.8C111.96 159.8 113.822 161.619 113.822 163.865Z",
    fill: "#F74848"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M217.312 81.7385C217.312 83.9836 215.451 85.8036 213.155 85.8036C210.859 85.8036 208.998 83.9836 208.998 81.7385C208.998 79.4934 210.859 77.6733 213.155 77.6733C215.451 77.6733 217.312 79.4934 217.312 81.7385Z",
    fill: "#EA5A4D"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M307.656 135.625V105.469L373.203 2.1875H400V43.125H384.453L346.094 103.906V105.156H441.016V135.625H307.656ZM384.922 162.188V126.406L385.703 113.203V2.1875H421.875V162.188H384.922Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M219.805 166.094C205.846 166.094 193.815 162.786 183.711 156.172C173.607 149.505 165.82 139.948 160.352 127.5C154.883 115 152.174 99.974 152.227 82.4219C152.279 64.8698 155.013 49.974 160.43 37.7344C165.898 25.4427 173.659 16.0938 183.711 9.68751C193.815 3.22917 205.846 0 219.805 0C233.763 0 245.794 3.22917 255.898 9.68751C266.055 16.0938 273.867 25.4427 279.336 37.7344C284.805 50.026 287.513 64.9219 287.461 82.4219C287.461 100.026 284.727 115.078 279.258 127.578C273.789 140.078 266.003 149.635 255.898 156.25C245.846 162.812 233.815 166.094 219.805 166.094ZM219.805 134.453C228.138 134.453 234.883 130.208 240.039 121.719C245.195 113.177 247.747 100.078 247.695 82.4219C247.695 70.8594 246.523 61.3281 244.18 53.8281C241.836 46.276 238.581 40.651 234.414 36.9531C230.247 33.2552 225.378 31.4062 219.805 31.4062C211.523 31.4062 204.831 35.599 199.727 43.9844C194.622 52.3177 192.044 65.1302 191.992 82.4219C191.94 94.1406 193.06 103.854 195.352 111.563C197.695 119.271 200.977 125.026 205.195 128.828C209.414 132.578 214.284 134.453 219.805 134.453Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M6.10352e-05 135.625V105.469L65.5469 2.1875H92.3438V43.125H76.7969L38.4376 103.906V105.156H133.359V135.625H6.10352e-05ZM77.2657 162.188V126.406L78.0469 113.203V2.1875H114.219V162.188H77.2657Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_2308_2056",
    x: 192.367,
    y: 137.812,
    width: 65.2124,
    height: 65.2122,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.05
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.00784314 0 0 0 0 0.0666667 0 0 0 0 0.258824 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2308_2056"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2308_2056",
    x: 201.035,
    y: 132.181,
    width: 39.3171,
    height: 69.2244,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.333333 0 0 0 0 0.0745098 0 0 0 0 0.0666667 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2308_2056"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2308_2056",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2308_2056",
    x: 200.474,
    y: 174.528,
    width: 40.4402,
    height: 40.4402,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.333333 0 0 0 0 0.0745098 0 0 0 0 0.0666667 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2308_2056"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2308_2056",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2308_2056",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(221.243 166.387) rotate(86.7398) scale(57.2649 52.5043)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#470F0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B73D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2308_2056",
    x1: 256.064,
    y1: 163.236,
    x2: 182.462,
    y2: 155.241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F74848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD2625"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2308_2056",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(223.078 170.691) rotate(-161.063) scale(41.2867 75.9204)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F74848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F74848"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.30e87d7cf01b99c94b0abbf23c0c8ce6.svg";
export { ForwardRef as ReactComponent };